import React from "react";
import classNames from "classnames";
import AirlineDisplay from "../../../../Components/AirlineDisplay/Index";
import {
  extractOrganizedTourFlightLegs,
  formatOrganizedTourFlightDateTime,
  formatOrganizedTourFlightDuration,
} from "../../../../utils/organizedTourProfileFlights";

function BaggageChip({ included, label, weight }) {
  return (
    <span
      className={classNames("otp-flight__chip", {
        "otp-flight__chip--on": included,
      })}
    >
      {label}
      {included && weight > 0 ? ` · ${weight} ק"ג` : ""}
    </span>
  );
}

function OrganizedTourFlightLegCard({ leg }) {
  const dep = formatOrganizedTourFlightDateTime(leg.depDate);
  const arr = formatOrganizedTourFlightDateTime(leg.arrDate);
  const handKg = Number(leg.maxHandLuggageWeight) || 0;
  const checkedKg = Number(leg.maxCheckedLuggageWeight) || 0;

  return (
    <article className="otp-flight">
      <div className="otp-flight__segment-label">{leg.segmentLabel}</div>
      <div className="otp-flight__main">
        <div className="otp-flight__airline">
          <AirlineDisplay
            leg={leg}
            flightNumber={leg.flightNumber}
            airlineId={leg.airlineId}
          />
        </div>
        <div className="otp-flight__timeline">
          <div className="otp-flight__endpoint">
            <span className="otp-flight__city">{leg.depCity || "—"}</span>
            <span className="otp-flight__time">{dep.time || "—"}</span>
            <span className="otp-flight__date">{dep.date}</span>
          </div>
          <div className="otp-flight__connector" aria-hidden>
            <span className="otp-flight__duration">
              {formatOrganizedTourFlightDuration(leg.duration)}
            </span>
            <span className="otp-flight__line" />
          </div>
          <div className="otp-flight__endpoint otp-flight__endpoint--arr">
            <span className="otp-flight__city">{leg.arrCity || "—"}</span>
            <span className="otp-flight__time">{arr.time || "—"}</span>
            <span className="otp-flight__date">{arr.date}</span>
          </div>
        </div>
        <div className="otp-flight__meta">
          {leg.flightClass ? (
            <span className="otp-flight__class">{leg.flightClass}</span>
          ) : null}
          <div className="otp-flight__baggage">
            <BaggageChip included={handKg > 0} label="תיק יד" weight={handKg} />
            <BaggageChip included={checkedKg > 0} label="מזוודה" weight={checkedKg} />
          </div>
        </div>
      </div>
    </article>
  );
}

export default function OrganizedTourFlightTimeline({ linkedFlights }) {
  const legs = extractOrganizedTourFlightLegs(linkedFlights);
  if (!legs.length) {
    return <p className="otp-empty">פרטי טיסה יוצגו לאחר טעינת הנתונים.</p>;
  }
  return (
    <div className="otp-flight-list">
      {legs.map((leg, i) => (
        <OrganizedTourFlightLegCard
          key={`${leg.flightNumber}-${leg.depDate}-${i}`}
          leg={leg}
        />
      ))}
    </div>
  );
}
